"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasNaughtyTokenType = exports.hasTokenType = exports.getVariableNames = void 0;
const types_1 = require("../parsers/types");
function getVariableNames(tokens) {
    return tokens
        .filter((t) => t.type === types_1.TokenType.VARIABLE)
        .map((t) => t.value);
}
exports.getVariableNames = getVariableNames;
function hasTokenType(tokens, tokenTypes) {
    return tokens.findIndex((t) => tokenTypes.includes(t.type)) !== -1;
}
exports.hasTokenType = hasTokenType;
const naughtyTokenTypes = [types_1.TokenType.INVALID, types_1.TokenType.UNKNOWN];
function hasNaughtyTokenType(tokens) {
    return hasTokenType(tokens, naughtyTokenTypes);
}
exports.hasNaughtyTokenType = hasNaughtyTokenType;
